module.exports = __webpack_public_path__ + "c6cfd4cd2ab699e746a9db99cb74bd2e.MP3";